/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface AuthRequestModel {
  /** @format uuid */
  id: string;
  otp: string;
}

export interface AuthResponseModel {
  id?: string;
  content?: string;
}

export interface DoclinkRequestModel {
  policy_number?: string;
  document_type?: string;
  source_system_id?: string;
  /** @format uuid */
  gv_id?: string;
  corro_record_id?: string;
  brand?: string;
}

export interface DoclinkResponseModel {
  /** @format uuid */
  id?: string;
}

export interface ErrorDetails {
  title?: string;
  type?: string;
}

export interface ValidateAndConfirmResponseModel {
  id?: string;
  channelId?: string;
  maskedMobileNumber?: string;
}

import axios, {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  HeadersDefaults,
  ResponseType,
} from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || "http://localhost:7173/api",
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[
            method.toLowerCase() as keyof HeadersDefaults
          ]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] =
        property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(
          key,
          isFileType ? formItem : this.stringifyFormItem(formItem)
        );
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (
      type === ContentType.FormData &&
      body &&
      body !== null &&
      typeof body === "object"
    ) {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (
      type === ContentType.Text &&
      body &&
      body !== null &&
      typeof body !== "string"
    ) {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData
          ? { "Content-Type": type }
          : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title OpenAPI Document on Azure Functions
 * @version 1.0.0
 * @baseUrl http://localhost:7173/api
 *
 * This is the OpenAPI Document on Azure Functions
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  corro = {
    /**
     * No description
     *
     * @tags Authentication
     * @name AuthCorroPost
     * @summary Submit OTP
     * @request POST:/corro/auth
     */
    authCorroPost: (
      body: AuthRequestModel,
      query?: {
        /** The channel we're using for auth i.e Computershare. Only used in debug to use mockcomputershare */
        Channel?: string;
        /** The mobile for auth while testing */
        Mobile?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<AuthResponseModel, ErrorDetails>({
        path: `/corro/auth`,
        method: "POST",
        query: query,
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Doclink
     * @name GenerateDoclinkPost
     * @summary Generates a doclink for the given inputs
     * @request POST:/corro/generate
     */
    generateDoclinkPost: (
      body: DoclinkRequestModel,
      params: RequestParams = {}
    ) =>
      this.request<DoclinkResponseModel, ErrorDetails>({
        path: `/corro/generate`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags HealthCheck
     * @name DigiCorroDeliveryHealthCheckGet
     * @summary Check to see if the DigiCorroDelivery API is current and working.
     * @request GET:/corro/healthcheck
     */
    digiCorroDeliveryHealthCheckGet: (params: RequestParams = {}) =>
      this.request<void, ErrorDetails>({
        path: `/corro/healthcheck`,
        method: "GET",
        ...params,
      }),
  };
  validateandconfirm = {
    /**
     * No description
     *
     * @tags ValidateAndConfirm
     * @name ValidateAndConfirmPost
     * @summary Validate item exists in the database and then confirm with OKTA
     * @request GET:/validateandconfirm
     */
    validateAndConfirmPost: (
      query: {
        /** The id of the item we're fetching */
        Id: string;
        /** The channel we're using for auth i.e Computershare. Only used in debug to use mockcomputershare */
        Channel?: string;
        /** The mobile for auth while testing */
        Mobile?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<ValidateAndConfirmResponseModel, ErrorDetails | string>({
        path: `/validateandconfirm`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
}
